import { memo, useCallback } from 'react';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps, useNavigation } from '@bonanza-social/navigation';

// Displays when a player attempts to place a bet but has insufficient
// balance, triggered by the SignalR 'InsufficientFundsBet' event.
function LowBalanceBottomSheet({ close }: BottomSheetExtendedProps) {
  const navigation = useNavigation();

  const handleOkClick = useCallback(() => {
    close();
    navigation.navigate('Home');
  }, [close, navigation]);

  return (
    <Box alignItems="center" gap="space-400">
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        locNS="games"
        locKey="lowBalanceTitle"
      />

      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        textAlign="center"
        locNS="games"
        locKey="lowBalanceMessage"
      />

      <Button
        width="100%"
        variant="primary"
        onPress={handleOkClick}
        locNS="games"
        locKey="lowBalanceShopButton"
      />
    </Box>
  );
}

export default memo(LowBalanceBottomSheet);
